var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"message",class:Object.assign({}, _vm.msgClass, _vm.$attrs.class)},'div',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.error? _vm.error.message: 'Parsed!')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }